import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"position":"relative","display":"inline-block","width":"100%"} }
const _hoisted_2 = { class: "d-flex justify-space-between" }
const _hoisted_3 = { class: "d-flex align-end" }
const _hoisted_4 = {
  key: 0,
  class: "mt-6 error--text"
}
const _hoisted_5 = { class: "f-body-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              class: "input-label",
              style: _normalizeStyle({ paddingLeft: Object.keys(_ctx.$attrs).includes('prepend-icon') ? '42px' : '0px' })
            }, [
              _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
              (_ctx.showRequired)
                ? (_openBlock(), _createElementBlock("small", _hoisted_4, "*"))
                : _createCommentVNode("", true)
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_v_btn, {
        class: "included",
        color: "primary",
        icon: "mdi-auto-fix",
        onClick: _ctx.keepSelectedTextHighlighten
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon),
          _createVNode(_component_v_menu, {
            modelValue: _ctx.menu,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menu) = $event)),
            activator: "parent"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, { class: "mt-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    onClick: _ctx.improveSeletedText,
                    loading: _ctx.processing,
                    small: "",
                    icon: "",
                    title: "Improve Selection"
                  }, null, 8, ["onClick", "loading"]),
                  _createVNode(_component_v_list_item, {
                    onClick: _ctx.completeSentece,
                    small: "",
                    icon: "",
                    title: "Complete"
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_v_list_item, {
                    onClick: _ctx.generate,
                    small: "",
                    icon: "",
                    title: "Generate"
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _withDirectives(_createVNode(_component_v_textarea, _mergeProps({
      disabled: _ctx.processing,
      loading: _ctx.processing,
      id: _ctx.id
    }, _ctx.$attrs, {
      "model-value": _ctx.modelValue,
      "onUpdate:modelValue": _ctx.valueChanged,
      maxlength: "5000"
    }), null, 16, ["disabled", "loading", "id", "model-value", "onUpdate:modelValue"]), [
      [_directive_click_outside, { handler: () => {}, include: _ctx.include }]
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialog) = $event)),
      "max-width": "800"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "scrollable-content" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              ref: "frmMain",
              "lazy-validation": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode(" Answer the Following Questions ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString((option as any).title), 1),
                        (_openBlock(), _createBlock(_component_v_radio_group, {
                          modelValue: (option as any).selected,
                          "onUpdate:modelValue": ($event: any) => (((option as any).selected) = $event),
                          key: index,
                          rules: [_ctx.validations.required],
                          row: "",
                          class: "mt-2"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((option as any).choices, (choice, i) => {
                              return (_openBlock(), _createBlock(_component_v_radio, {
                                key: i,
                                label: choice,
                                value: choice,
                                color: "red"
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "rules"]))
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      class: "secondary_btn",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialog = false))
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode("Cancel")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      class: "primary_btn",
                      onClick: _ctx.saveSelectedAnswers
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("Save")
                      ])),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}